import { render, staticRenderFns } from "./FooterCom.vue?vue&type=template&id=12093fcc&scoped=true"
import script from "./FooterCom.vue?vue&type=script&lang=js"
export * from "./FooterCom.vue?vue&type=script&lang=js"
import style0 from "./FooterCom.vue?vue&type=style&index=0&id=12093fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12093fcc",
  null
  
)

export default component.exports